import React from 'react';

const ZedworxLogo = ({ className = "", width = 180, height = 50, variant = "default" }) => {
  const isDarkBg = variant === "header" || variant === "footer";
  
  return (
    <div className={`zedworx-logo ${className}`} style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
      {/* Logo Image - just the icon part shows on dark bg */}
      <img 
        src="/zedworx-logo.png" 
        alt="Zedworx" 
        style={{ 
          height: '45px', 
          width: 'auto',
          objectFit: 'contain'
        }} 
      />
      
      {/* Add text for dark backgrounds since the logo text doesn't show */}
      {isDarkBg && (
        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
          <div style={{ 
            fontFamily: "'Montserrat', Arial, sans-serif", 
            fontSize: '20px', 
            fontWeight: '700', 
            letterSpacing: '1px',
            lineHeight: '1.2',
            color: '#C5A059'
          }}>
            ZEDWORX
          </div>
          <div style={{ 
            fontFamily: "'Roboto', Arial, sans-serif", 
            fontSize: '7px', 
            fontWeight: '500', 
            color: '#C5A059',
            letterSpacing: '1.5px',
            marginTop: '2px'
          }}>
            LEGISLATIVE INTELLIGENCE
          </div>
        </div>
      )}
    </div>
  );
};

export default ZedworxLogo;
